import Styles from './style.postcss';

import React from 'react';
import { PageCard, Grid } from 'omni-common-ui';
import PageActivitiesSelector from 'components/PageActivitiesSelector';
import PropTypes from 'prop-types';
import { activityDeepMerge } from 'data/CoveredInClass/accessors';

const PageActivitiesPart = (props) => {
  const { isEditMode, pageActivities, template } = props;
  let renderActivities = pageActivities;

  if (! isEditMode && template) {
    renderActivities = activityDeepMerge(template, pageActivities);
  }

  if (! renderActivities || renderActivities.size === 0) {
    return <div />;
  }

  return <PageCard className={Styles.PageActivitiesPart}>
    <PageCard.Heading text="Pages & Activities" />
    <PageCard.Content>
      {renderPageActivitiesContent()}
    </PageCard.Content>
  </PageCard>;

  function renderPageActivitiesContent() {
    if (isEditMode) {
      return <Grid>
        <Grid.Group>
          {
            pageActivities.map((pageActivitiesItem, index) => <Grid.Item xs={12} sm={6} md={4}>
              <PageActivitiesSelector title={pageActivitiesItem.cicActivityName}
                  onActivityChecked={(ChangedItemIndex, activities) =>
                    onPageActivitiesChanged(ChangedItemIndex, activities)}
                  activities={pageActivitiesItem.cicActivityItems}
                  index={index}
                  isEditMode />
            </Grid.Item>)
          }
        </Grid.Group>
      </Grid>;
    }

    return <div className={Styles.PageActivitiesPart_container_view}>
      <Grid>
        <Grid.Group>
          {
            renderActivities.map((pageActivitiesItem) => <Grid.Item xs={12} sm={6} md={4}>
              <PageActivitiesSelector title={pageActivitiesItem.cicActivityName}
                  activities={pageActivitiesItem.cicActivityItems} />
            </Grid.Item>)
          }
        </Grid.Group>
      </Grid>
    </div>;
  }

  function onPageActivitiesChanged(ChangedItemIndex, activities) {
    const pageActivitiesItem = pageActivities.get(ChangedItemIndex);
    const newPageActivities = pageActivities.set(
      ChangedItemIndex,
      pageActivitiesItem.set('cicActivityItems', activities)
    );
    props.onPageActivitiesChanged(newPageActivities);
  }
};

PageActivitiesPart.propTypes = {
  isEditMode: PropTypes.bool,
  pageActivities: PropTypes.object.isRequired,
  template: PropTypes.object,
  onPageActivitiesChanged: PropTypes.func,
};

export default PageActivitiesPart;



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClass/PageActivitiesPart/index.jsx